import * as React from 'react';

type VariantCountSetter = (count: number) => void;
type VariantCountContextValues = [number | null, VariantCountSetter];

const VariantCountContext =
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  React.createContext<VariantCountContextValues>(null);

/**
 * @description A hook for reading and setting the variantCount prop.
 */
function useVariantCount() {
  const context = React.useContext(VariantCountContext);

  if (!context) {
    throw new Error(
      'useVariantCount must be used within a VariantCountProvider',
    );
  }

  return context;
}

function VariantCountProvider(props: any) {
  const [variantCount, setVariantCount] = React.useState<number | null>(null);

  const value = React.useMemo(
    () => [variantCount, setVariantCount],
    [variantCount],
  );

  return <VariantCountContext.Provider value={value} {...props} />;
}

export { VariantCountProvider, useVariantCount };
